"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * LockInfo represents domain object describing lock data
 *
 * @author VBr
 */


var LockInfo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(LockInfo, _DomainObject_1$Domai);

  /**
   * Constructs product instance.
   *
   * @param id the internal id of product
   * @param tag lock tag
   * @param resourceType resource type
   * @param resourceId resource id
   * @param issued date when the lock was created
   * @param cases workflow cases lock relates to
   * @param issuers users related to lock
   */
  function LockInfo(id, tag, resourceType, resourceId, issued, cases, issuers) {
    var _this;

    _classCallCheck(this, LockInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LockInfo).call(this));
    _this.id = id;
    _this.tag = tag;
    _this.resourceType = resourceType;
    _this.resourceId = resourceId;
    _this.issued = issued;
    _this.cases = cases;
    _this.issuers = issuers;
    return _this;
  }

  return LockInfo;
}(DomainObject_1.DomainObject);

exports.LockInfo = LockInfo; // tslint:disable-next-line:member-ordering

LockInfo.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(LockInfo.name);
  return {
    id: builder.id('id'),
    tag: builder.str('tag'),
    resourceType: builder.str('resourceType'),
    resourceId: builder.str('resourceId'),
    issued: builder.date('issued'),
    cases: builder.arr(builder.str('cases')),
    issuers: builder.arr(builder.str('issuers'))
  };
}();